const LOADING = {
  IMPORT: "Importing Please Wait",
};

const ACTION_MESSAGE ={
  STATUS_CHANGE:"do you wish to mark office is shutdown"
}

export default { LOADING,ACTION_MESSAGE };
